import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form__label-wrapper" };
const _hoisted_2 = ["for", "title"];
const _hoisted_3 = ["title"];
import { computed } from 'vue';
import Icon from "../Icon.vue";
import trans from "../../services/Translator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FormLabel',
    props: {
        form: {},
        field: {},
        fieldId: {}
    },
    setup(__props) {
        const props = __props;
        const fieldOptions = computed(() => props.field.options || {});
        const label = computed(() => {
            return props.field.label || trans(props.form.name + '_' + props.field.name);
        });
        return (_ctx, _cache) => {
            const _directive_b_tooltip = _resolveDirective("b-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("label", {
                    for: __props.fieldId,
                    class: _normalizeClass(["form__label", { 'form__label--required': fieldOptions.value.required && __props.field.type !== 'bool' }]),
                    title: label.value
                }, _toDisplayString(label.value), 11, _hoisted_2),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (fieldOptions.value.help)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "form__help",
                        title: fieldOptions.value.help
                    }, [
                        _createVNode(Icon, {
                            name: "question-circle",
                            "icon-style": "light"
                        })
                    ], 8, _hoisted_3)), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            {
                                hover: true,
                                righttop: true
                            }
                        ]
                    ])
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
